export const POSTHOG_FEATURE_FLAGS = {
  // feature flag to enable the service page overhaul
  SERVICE_PAGE_OVERHAUL: "servicePageOverhaul",
  // feature flag to enable the star variant of the review request email to prospects
  REVIEW_REQUEST_STAR_VARIANT: "reviewRequestStarVariant",
  // feature flag to enable the admin Timesheets dashboard
  TIMESHEETS_DESKTOP_V1: "timesheetsDesktopV1",
  // feature flag to enable the qbo connections page,
  QBO_CONNECTIONS: "qboConnections",
  // feature flag to enable the calendar integrations (google + ics) UI surfaces.
  // gates the OAuth connect flow in PR 2 and settings UI in PR 4.
  INTEGRATIONS_CALENDAR_ENABLED: "integrationsCalendarEnabled",
  // feature flag to enable the multi-invoice / payment schedules flow
  // (billing plan panel, one-vs-split chooser, inline quote approve).
  MULTI_INVOICE: "multiInvoiceEnabled",
  // kill switch for the Clerk auth-recovery interceptor (PR #1935): ON = 401
  // refresh+replay with fail-soft timeouts and terminal redirect, no global
  // SWR redirect; OFF = legacy behavior (no recovery, redirect to /dashboard
  // on 401/403). Temporary release flag — delete after 100% rollout is stable.
  AUTH_RECOVERY_INTERCEPTOR: "authRecoveryInterceptor",
} as const;

export type PostHogFeatureFlag = (typeof POSTHOG_FEATURE_FLAGS)[keyof typeof POSTHOG_FEATURE_FLAGS];
